import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down-black.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_plane_flight_line.svg'
import _imports_2 from '@/app/ui/assets/svg/new-cod.svg'
import _imports_3 from '@/app/ui/assets/svg/new-dfod.svg'
import _imports_4 from '@/app/ui/assets/svg/ics_f_cursor.svg'


const _hoisted_1 = { class: "rounded-lg border border-gray-lp-1400" }
const _hoisted_2 = { class: "border-b border-gray-lp-1400 p-2" }
const _hoisted_3 = { class: "flex flex-row items-center justify-between" }
const _hoisted_4 = {
  class: "flex flex-col",
  style: {"gap":"2px"}
}
const _hoisted_5 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_6 = { class: "text-gray-lp-300 text-base font-semibold" }
const _hoisted_7 = {
  class: "rounded-2xl bg-gray-lp-200 px-2 text-xs text-gray-lp-300 font-medium",
  style: {"width":"fit-content"}
}
const _hoisted_8 = { class: "text-xs font-medium text-gray-lp-800" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col gap-1",
  style: {"width":"96%"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-lp-600" }, "Tanggal booking", -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_13 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_14 = { class: "text-xs font-medium text-gray-lp-800 whitespace-nowrap overflow-ellipsis overflow-hidden" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_16 = { class: "flex flex-row items-baseline justify-between mt-3" }
const _hoisted_17 = { class: "flex flex-col gap-1" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-lp-600" }, "Rute pengiriman", -1)
const _hoisted_19 = { class: "flex flex-row items-center font-semibold text-gray-lp-300" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  width: "64",
  src: _imports_1,
  alt: "plane-line"
}, null, -1)
const _hoisted_21 = { class: "flex flex-col gap-1" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-lp-600 text-right" }, "Jenis pengiriman", -1)
const _hoisted_23 = { class: "flex flex-row items-center gap-2" }
const _hoisted_24 = {
  key: 0,
  src: _imports_2,
  style: {"height":"15px"}
}
const _hoisted_25 = {
  key: 1,
  src: _imports_3,
  style: {"height":"15px"}
}
const _hoisted_26 = {
  key: 2,
  class: "border border-gray-lp-1600 bg-gray-lp-1000 text-gray-lp-800 text-10px px-3 py-1",
  style: {"border-radius":"4px"}
}
const _hoisted_27 = { class: "flex flex-col gap-1 mt-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-lp-600" }, "Estimasi pengiriman", -1)
const _hoisted_29 = { class: "flex flex-row items-center gap-1" }
const _hoisted_30 = {
  key: 0,
  class: "text-sm font-medium rounded-2xl px-2 bg-green-lp-300 text-green-lp-400"
}
const _hoisted_31 = {
  key: 1,
  class: "text-sm font-medium rounded-2xl px-2 bg-red-lp-600 text-red-lp-100"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  width: "18",
  height: "18"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Lacak ")
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "text-xl text-gray-lp-300 font-semibold" }, "Detail tracking STT", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrackingV2 = _resolveComponent("TrackingV2")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.detailData.sttNo), 1),
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.detailData.lastStatus), 1)
            ]),
            _createVNode("div", _hoisted_8, "Tanggal diperbarui: " + _toDisplayString(_ctx.updatedAt) + ".", 1)
          ]),
          (!_ctx.isSummary)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "p-2 hover:bg-gray-100 rounded-full",
                onClick: _cache[1] || (_cache[1] = () => _ctx.isCollapsed = !_ctx.isCollapsed)
              }, [
                _createVNode("img", {
                  src: _imports_0,
                  class: ["w-6 h-6 transition-transform duration-200", { 'transform rotate-180': !_ctx.isCollapsed }],
                  alt: "chevron"
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", {
        class: [{'h-0 p-0 overflow-hidden hidden': _ctx.isCollapsed}, {'px-2 py-2.5': !_ctx.isCollapsed}]
      }, [
        (!_ctx.isSummary)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.bookingDate), 1),
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.detailData.posName), 1),
                  (_ctx.detailData.posLevel)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode("img", {
                          width: "16",
                          height: "16",
                          src: require(`@/app/ui/assets/svg/level/${_ctx.level?.icon}.svg`),
                          alt: "level"
                        }, null, 8, ["src"]),
                        _createVNode("div", {
                          class: `text-xs font-medium text-${_ctx.level?.color}`
                        }, _toDisplayString(_ctx.level?.title), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode("div", _hoisted_19, [
              _createTextVNode(_toDisplayString(_ctx.detailData.origin) + " ", 1),
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.detailData.destination), 1)
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode("div", _hoisted_23, [
              _createVNode("img", {
                src: _ctx.mapProductLogo(_ctx.detailData.productType),
                style: {"height":"16px"}
              }, null, 8, ["src"]),
              (_ctx.detailData.isCOD && !_ctx.detailData.isDFOD)
                ? (_openBlock(), _createBlock("img", _hoisted_24))
                : _createCommentVNode("", true),
              (_ctx.detailData.isCOD && _ctx.detailData.isDFOD)
                ? (_openBlock(), _createBlock("img", _hoisted_25))
                : _createCommentVNode("", true),
              (!_ctx.detailData.isCOD && !_ctx.detailData.isDFOD)
                ? (_openBlock(), _createBlock("div", _hoisted_26, " Non COD "))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode("div", _hoisted_29, [
            _createVNode("div", {
              class: ["font-semibold text-red-lp-100", {'text-gray-lp-300': _ctx.detailData.isOnSLA}]
            }, _toDisplayString(_ctx.estimationDate), 3),
            _withDirectives(_createVNode("div", null, [
              (_ctx.detailData.isOnSLA)
                ? (_openBlock(), _createBlock("div", _hoisted_30, "On SLA"))
                : (_openBlock(), _createBlock("div", _hoisted_31, "Over SLA"))
            ], 512), [
              [_vShow, _ctx.showBadgeSLA]
            ])
          ])
        ])
      ], 2),
      _createVNode("div", {
        class: [{'h-0 p-0 border-0 overflow-hidden hidden': _ctx.isCollapsed}, {'border-t border-gray-lp-1400 p-2 flex flex-row justify-center items-center': !_ctx.isCollapsed}]
      }, [
        _createVNode("button", {
          class: "underline text-sm text-red-lp-100 font-semibold flex flex-row justify-center items-center gap-1",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTrackingSTT && _ctx.onTrackingSTT(...args)))
        }, [
          _hoisted_32,
          _hoisted_33
        ])
      ], 2)
    ]),
    (_ctx.isShowTrackingModal)
      ? (_openBlock(), _createBlock(_component_ModalV2, {
          key: 0,
          class: "tracking-modal-pusat-resolusi-v2",
          title: "Detail tracking STT",
          isCustomTitle: "",
          onClose: _ctx.onCloseTrackingModal,
          showFooter: false
        }, {
          "custom-title": _withCtx(() => [
            _hoisted_34
          ]),
          content: _withCtx(() => [
            _createVNode(_component_TrackingV2, { isForModal: true })
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}